export default {
  signUpView: {
    event: "signup_view",
    eventCategory: "LoginApp_Page_View",
    eventAction: "PageView",
  },
  signUpSuccess: {
    event: "signup",
    eventCategory: "LoginApp_SignUp_Sucess",
    eventAction: "signUpSucess",
  },
  signInView: {
    event: "signin_view",
    eventCategory: "LoginApp_Page_View",
    eventAction: "PageView",
  },
  signInSucess: {
    event: "signin",
    eventCategory: "LoginApp_SignIn_Sucess",
    eventAction: "signInSucess",
  },
};
